import { ALERT_DIAL_RESULT_LIST } from "../constants/constants";
import { MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { triggerNotifications } from "../Helpers/helperMessages";
import { Singleton } from "../Singletons/Singleton";

const language = new Singleton();

export const STRATEGIES_ALERTS = {
  "MANUAL_CALL": function (message,that) {
    let messageEnglish = language.getText('alert-' + message.Code);
    if(message.code>=1500 || message.code<=1511)
    {
      messageEnglish = ALERT_DIAL_RESULT_LIST[message.code];
    }
    const alertObject = {
      module: message.Module,
      message: messageEnglish,
      idDialResult: message.DialResultID,
    };
    triggerNotifications(that, message.Code, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, language.getText('alert-' + message.Code) + ' idDialResult: ' + message.DialResultID);
    return alertObject;
  },
  "TRANSFER_CALL": function (message) {
    const language = new Singleton();
    var alertObject = {
      module: "TRANSFER_CALL",
      message:language.getText('alert-' + message.AlertCode),
      code: message.AlertCode,
    };
    return alertObject;
  }
}

